<template>
    <div class="windowConfirm__container">
        <ButtonComponent class = "changePasswordModal__container__button"
                       label = "Нет"
                       elementType = "default-bg"
                       :elementInLoading="this.requesting"
                       :elementStatusModifier="this.requesting ? 'disabled' : null"
                       @click_to_button="this.cancelAccountDeletion" />
        <ButtonComponent class = "changePasswordModal__container__button"
                        label = "Да, удалить"
                        elementType = "default-bg"
                        :elementInLoading="this.requesting"
                        elementStatusModifier="danger"
                        @click_to_button="this.deleteAccount" />
    </div>
</template>

<script>

import ButtonComponent from '@/units/forms/RichButton.vue';

import {userDeleteRequest} from '@/assets/dataSources/auth/userDeleteRequest';

export default {
  components: {
    ButtonComponent,
  },
  data: () => ({
    requesting: false,
  }),
  methods: {
    deleteAccount() {
      if (this.requesting) {
        return;
      }

      this.requesting = true;

      userDeleteRequest();
    },
    cancelAccountDeletion() {
      this.$emit('result', null);
    },
  },
};
</script>

<style lang="less">
.windowConfirm {
  &__container {
    display: flex;
    justify-content: center;
    align-items: center;
    // height: 10vh;
    gap: 10px;
  }

}
</style>
